import React from 'react';
import { router } from '@inertiajs/react';
import Layout from '../../components/Layout.jsx';
import BillingSection from '../../components/BillingSection.jsx';

export default function Billing({ subscriptions = [], invoices = [] }) {
  const handleCancel = (subscriptionId) => {
    router.post('/student_purchase/subscriptions/cancel', { subscription_id: subscriptionId });
  };

  const handleResume = (subscriptionId) => {
    router.post('/student_purchase/subscriptions/resume', { subscription_id: subscriptionId });
  };

  return (
    <Layout>
      <div className="max-w-6xl mx-auto p-6 sm:p-8 space-y-6">
        <div>
          <h1 className="text-3xl font-bold tracking-tight text-gray-900">Billing</h1>
          <p className="mt-1 text-sm text-gray-500">Your subscriptions, invoices, and payment history.</p>
        </div>

        <BillingSection
          subscriptions={subscriptions}
          invoices={invoices}
          onCancel={handleCancel}
          onResume={handleResume}
        />
      </div>
    </Layout>
  );
}
